import {Injectable} from '@angular/core';
import {AuthService} from '../../../../firebase/src/lib/services/auth.service';

@Injectable({
    providedIn: 'root'
})
export class FeaturesService {

    constructor(
        private auth: AuthService
    ) {
    }


    get isMil() {
        const state = localStorage.getItem('user_state');
        const data = state && typeof state !== 'undefined' ? JSON.parse(state) : false;
        return data ? data?.features?.find((el: any) => el === 'military')?.length > 0
            : false;
    }

    get isBeta() {
        const state = localStorage.getItem('user_state');
        const data = state && typeof state !== 'undefined' ? JSON.parse(state) : false;
        return data ? data?.features?.find((el: any) => el === 'beta-test')?.length > 0
            : false;
    }

    get hasReport() {
        return !!this.auth.userState && !!this.auth.userState?.dashboards && this.auth.userState?.dashboards.length;
    }
}
